import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

/** Formats a Zimbabwe National ID (e.g. `08-123456D53`) while typing. */
@Directive({
  selector: '[libZimbabweNationalIdFormatter]',
})
export class ZimbabweNationalIdFormatterDirective {
  private readonly el = inject(ElementRef);
  private readonly control = inject(NgControl);

  @HostListener('input') onInput(): void {
    const inputValue: string = this.el.nativeElement.value
      .replace(/[^0-9a-zA-Z-]/g, '')
      .toUpperCase();

    const match = inputValue.match(/^(\d{0,2})-?(\d{0,7})?([A-Z]?)?(\d{0,2})?/);

    if (match) {
      let formattedValue = '';
      if (match[1]) formattedValue += match[1];
      if (match[2]) formattedValue += '-' + match[2];
      if (match[3]) formattedValue += match[3];
      if (match[4]) formattedValue += match[4];

      this.el.nativeElement.value = formattedValue;
      this.control.control?.setValue(formattedValue, { emitEvent: false });
    }
  }
}
